import { C, P0, S, abs, fillAt, max, rotPts, sq } from '../../geometry';

export const sheep = {
  name: 'Sheep',
  colors: ['#1FA2D6', '#161616'],
  draw(m, t) {
    let ph = 0.3 * S(t),
      A = 3.2,
      R0 = 28,
      eL = -4 + 4 * S(t * 1.4),
      eR = -4 + 4 * S(t * 1.4 + 1),
      lg = [0, 0],
      pose = P0();
    if (m === 'happy') {
      ph = t * 3;
      A = 4;
      eL = eR = 10 + 12 * S(t * 9);
      lg = [3 * S(t * 12), -3 * S(t * 12)];
      pose.ty = -3 * abs(S(t * 6));
    }
    // Thinking: the fleece keeps rolling round like a cloud while the ears flick in turn.
    if (m === 'thinking') {
      ph = t * 2.4;
      eL = -4 + 24 * max(0, S(t * 2.4));
      eR = -4 + 24 * max(0, -S(t * 2.4));
      pose.rot = 3 * S(t * 1.2);
    }
    if (m === 'talking') {
      A = 3.2 + 1.4 * max(0, S(t * 10));
      eL = eR = 6 * max(0, S(t * 10));
    }
    if (m === 'surprised') {
      R0 = 30;
      A = 4.5;
      eL = eR = 32;
      pose.ty = -2;
    }
    if (m === 'paused') {
      R0 = 27;
      A = 2.4;
      eL = eR = -32;
      pose.ty = 2;
      pose.sy = 0.94;
    }
    const wool = [...Array(73)].map((_, k) => {
      const th = (k / 72) * 2 * Math.PI,
        r = R0 + A * abs(S(4.5 * th + ph));
      return [50 + r * C(th), 52 + r * S(th) * 0.94];
    });
    return {
      strokes: [
        {
          c: 'b',
          pts: [
            [41, 78],
            [41, 90 + lg[0]],
          ],
        },
        {
          c: 'b',
          pts: [
            [59, 78],
            [59, 90 + lg[1]],
          ],
        },
        { c: 'a', pts: wool, n: 72 },
        {
          c: 'b',
          pts: rotPts(
            [
              [37, 53],
              [28, 61],
            ],
            37,
            53,
            eL
          ),
        },
        {
          c: 'b',
          pts: rotPts(
            [
              [63, 53],
              [72, 61],
            ],
            63,
            53,
            -eR
          ),
        },
        { c: 'b', pts: sq(50, 57, 14, 15.5, 2.4), n: 26 },
      ],
      eyes: { x: 50, y: 56 },
      pose,
    };
  },
  eyesOn: 'b',
  solid: (f) => fillAt(f, 2, 5),
};
